import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Spinner } from '@ingrid/luterkort-react';

import { TrackingEventEnum } from '~src/main/hooks/useTracking';

import { useShipmentHydrateMutation } from '../mutations';
import { useShipmentDetailsQuery } from '../queries';
import { ShipmentUpsert } from '../types';
import { CreatePage } from './page';

export function DuplicatePage() {
  const [shipment, setShipment] = useState<ShipmentUpsert>();
  const { id } = useParams();

  const originalShipment = useShipmentDetailsQuery({ id: id });
  const hydrateMutation = useShipmentHydrateMutation();

  useEffect(() => {
    async function init() {
      if (!shipment) {
        setShipment(await hydrateMutation.mutateAsync(originalShipment));
      }
    }

    void (async () => {
      await init();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (hydrateMutation.isIdle || hydrateMutation.isPending) {
    return <Spinner />;
  }

  return (
    <CreatePage
      onSuccessEvent={TrackingEventEnum.ShipmentCreateDuplicateCompleted}
      onErrorEvent={TrackingEventEnum.ShipmentCreateDuplicateFailed}
      onInitEvent={TrackingEventEnum.ShipmentCreateDuplicateStart}
      error={hydrateMutation.error?.message}
      shipment={shipment}
    />
  );
}
